@if (showLauncher()) {
    <div class="floating-launcher fixed bottom-6 right-4 z-50 shadow-lg" [class.floating-launcher--open]="showDialog()">
        <app-button
            variant="primary"
            [label]="'QUESTIONS.ASK.TRIGGER' | translate"
            endIcon="/icons/alert.svg"
            [ariaLabel]="'QUESTIONS.ASK.TRIGGER' | translate"
            (onClick)="open()" />
    </div>

    <app-ask-question-dialog [visible]="showDialog()" (visibleChange)="showDialog.set($event)" />
}
